import { Component } from '@angular/core';
import { Field } from '../../field';
import { LayoutService } from '../../layout.service';
import * as accounting from 'accounting';
import * as g from 'src/app/globals';

@Component({
  selector: 'app-input-amount',
  templateUrl: './input-amount.component.html',
  styleUrls: ['./input-amount.component.less'],
})
export class InputAmountComponent extends Field {
  constructor(public layoutService: LayoutService) {
    super(layoutService);
  }

  formatterAmount(value: number): string {
    if (value === null || isNaN(value)) {
      value = 0;
    }

    return accounting.formatNumber(
      value,
      g.companyConfiguration.AmountDecimal,
      g.companyConfiguration.ThousandSep,
      g.companyConfiguration.DecimalSep
    );
  }
}
